<template>
  <div class="margin-top-20">
    <div class="row">
      <div class="col-md-12 col-lg-12 col-xl-5 mb-3">
        <div class="pre-class-school-list__filter__action display-flex display-flex-space-between">
          <div class="wrap-left display-flex">
            <div class="item item__key input-custom-icon">
              <input v-model.lazy="paramQueryData.keyword" v-debounce="300" type="text" placeholder="Tìm kiếm lớp/ nhóm"
                class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width filter-keyword" />
              <i class="icon-search font-size-16 primary-color"></i>
            </div>
            <!-- <a href="javascript:;" @click="toggleCollapseGroup"
                            class="btn-collapse btn border-rd-20 font-size-15 filter-btn"
                            :class="{ 'btn-main': openCollapseFilterGroup, 'btn-main-light': !openCollapseFilterGroup }">
                            Bộ lọc <i class="icon-arrow-down font-size-12"
                                :class="{ 'color-light': openCollapseFilterGroup, 'primary-color': !openCollapseFilterGroup }"></i>
                        </a> -->
          </div>
        </div>
        <div class="wrap-table-assign" v-if="listDataAssign.length > 0">
          <vueCustomScrollbar class="b-scroll-table">
            <b-table striped hover :fields="fieldsTableDataAssign" :items="listDataAssign">
              <!-- <template #head(stt)="data">
                <span class="col-table text-center">{{ data.label }}</span>
              </template> -->

              <template #head(name)="data">
                <div class="col-table text-center">{{ data.label }}</div>
              </template>
              <template #head(submissionRate)="data">
                <div class="col-table text-center">{{ data.label }}</div>
              </template>
              <template #head(duration)="data">
                <div class="col-table text-center">{{ data.label }}</div>
              </template>

              <template #cell(name)="row">
                <span @click="handleGetListUserAssign(row.item)" class="mr-1 field-name">
                  <div class="text-center">{{ row.item.name }}</div>
                </span>
              </template>
              <template #cell(submissionRate)="row">
                <div class="text-center">{{ formatNumber(row.item.submissionRate) }}%</div>
              </template>

              <template #cell(duration)="row">
                <div class="position-rel text-center">
                  <div class="col-table">{{ moment(row.item.duration).format("DD/MM/YYYY") }}
                    <img @click="handleEditDuration(row)" class="icon-edit" src="@/assets/img/edit.png" />
                  </div>
                  <DropdownEditDuration @handleDone="handleDoneUpdateDuration" @hideDropdown="hideDropdownEditDuration"
                    v-if="itemCurrentSelectedId == row.item.id" :type="3" :item="row.item" />
                </div>
              </template>
              <template #cell(action)="row">
                <span @click="handleRecoveryAssign(row)" class="mr-1 btn-delete">
                  Thu hồi
                </span>
              </template>
            </b-table>
          </vueCustomScrollbar>
        </div>
        <div class="text-center" v-else>Danh sách lớp không có thông tin</div>
      </div>
      <div class="col-md-12 col-lg-12 col-xl-7">
        <div class="pb-2" v-if="itemCurrentSelected">
          <h5>
            <strong>{{ itemCurrentSelected.name }}</strong>
          </h5>
        </div>
        <div class="wrap-left display-flex">
          <div class="item item__key input-custom-icon">
            <input v-model.lazy="keyword" v-debounce="300" type="text" placeholder="Tìm kiếm học sinh theo tên"
              class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width search-user" />
            <i class="icon-search font-size-16 primary-color"></i>
          </div>
        </div>
        <div class="wrap-table-assign" v-if="listDataUserAssign.length > 0">
          <vueCustomScrollbar class="b-scroll-table">
            <b-table striped hover :fields="fieldsTableUserAssign" :items="listDataUserAssign">
              <template #head(stt)="data">
                <div class="col-table text-center">{{ data.label }}</div>
              </template>

              <template #head(name)="data">
                <div class="col-table text-center">{{ data.label }}</div>
              </template>
              <template #head(isComplete)="data">
                <div class="col-table text-center">{{ data.label }}</div>
              </template>
              <template #head(duration)="data">
                <div class="col-table text-center">{{ data.label }}</div>
              </template>
              <template #head(point)="data">
                <div class="col-table text-center">{{ data.label }}</div>
              </template>

              <template #cell(stt)="row">
                <div class="col-table text-center">{{ row.item.stt }}
                </div>
              </template>
              <template #cell(name)="row">
                <div class="col-table text-center">{{ row.item.name }}
                </div>
              </template>

              <!-- <template #cell(isComplete)="row">
                <div class="col-table text-center"
                  >{{ row.item.isComplete }}
                  </div>
              </template> -->

              <template #cell(isComplete)="row">
                <div class="text-center">
                  <img v-if="row.item.isComplete" class="icon-check-complete" src="@/assets/img/check.png" />
                  <img v-else class="icon-check-complete" src="@/assets/img/close.png" />
                </div>
              </template>
              <template #cell(duration)="row">
                <div class="col-table text-center">{{
                  row.item.isComplete ? moment(row.item.duration).format("DD/MM/YYYY") : '' }}
                </div>
              </template>
              <template #cell(point)="row">
                <div class="col-table text-center">{{ row.item.isComplete ? formatNumber(row.item.point) : '' }}</div>
              </template>
            </b-table>
          </vueCustomScrollbar>
        </div>
        <div class="text-center" v-else>Danh sách lớp không có thông tin</div>
      </div>
    </div>
    <div class="btn-add-class-assigned">
      <div class="display-flex-center">
        <a href="javascript:;" class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
          @click="handleAssignLesson">
          <img class="icon-plus" src="@/assets/img/plus.png" />
          <img class="icon-plus" src="@/assets/img/plus-hover.png" />
          Thêm lớp được giao
        </a>
      </div>
    </div>

    <ModalAssignExcercise :item="dataLesson" v-if="isOpenModalAssignExcercise" @closeModal="closeModalAssignExcercise"
      :type="3" @handleDone="handleDoneModalAssignExcercise" />

    <ModalRecoveryAssign :dataLesson="dataLesson" :itemCurrentSelected="itemCurrentSelected" :type="3"
      v-if="isOpenModalRecoveryAssign" @closeModal="closeModalRecoveryAssign"
      @handelRecoveryDone="handelRecoveryDone" />
    <!-- <ModalEditDuration
      @handleDone="handleDoneUpdateDuration"
      @closeModal="closeModalEditDuration"
      v-if="isOpenModalEditDuration"
      :type="3"
      :item="itemCurrentSelected"
    /> -->
  </div>
</template>
<script>
import debounce from "@/directives/debounce";
import {
  getListUserAssingExcerciseByClassSchoolId,
  getListClassSchoolGroupAssignExcercise,
  getListUserAssingExcerciseByGroupId,
  getDetail,
} from "./../../../_api/LessonClassSchoolServices";
import ModalEditDuration from "./ModalEditDuration";
import DropdownEditDuration from "./DropdownEditDuration";
import moment from "moment";
import vueCustomScrollbar from "vue-custom-scrollbar";
import ModalRecoveryAssign from "./ModalRecoveryAssign";
import ModalAssignExcercise from "./ModalAssignExcercise";
export default {
  directives: { debounce },
  components: {
    ModalEditDuration,
    vueCustomScrollbar,
    ModalRecoveryAssign,
    ModalAssignExcercise,
    DropdownEditDuration,
  },
  data() {
    return {
      isOpenModalAssignExcercise: false,
      isOpenModalEditDuration: false,
      isOpenModalRecoveryAssign: false,
      lessonClassSchoolId: 0,
      examId: 0,
      keyword: "",
      openCollapseFilterGroup: false,
      fieldsTableDataAssign: [
        { key: "name", label: "Lớp/ nhóm" },
        { key: "submissionRate", label: "Tỷ lệ nộp bài" },
        { key: "duration", label: "Thời hạn hoàn thành" },
        { key: "action", label: "" },
      ],
      fieldsTableUserAssign: [
        { key: "stt", label: "STT" },
        { key: "name", label: "Họ tên học sinh" },
        { key: "isComplete", label: "Hoàn thành" },
        { key: "duration", label: "Thời gian hoàn thành" },
        { key: "point", label: "Điểm số" },
      ],
      listDataAssign: [],
      paramQueryData: {
        keyword: "",
        id: 0,
        examId: 0,
        type: 3,
      },
      itemCurrentSelected: null,
      itemCurrentSelectedId: 0,
      listDataUserAssign: [],

      dataLesson: {},
    };
  },
  watch: {
    "paramQueryData.keyword": "getListClassGroupAssignExcercise",
    'keyword': 'getListUserAssign'
  },
  mounted() {
    this.lessonClassSchoolId = this.paramQueryData.id =
      this.$route.query.lessonId;
    this.examId = this.paramQueryData.examId = this.$route.query.examId;
    this.getListClassGroupAssignExcercise();
    this.getDetailLesson();
  },
  methods: {
    moment,

    closeModalAssignExcercise() {
      console.log("close model");
      this.isOpenModalAssignExcercise = false;
    },
    handleAssignLesson() {
      this.isOpenModalAssignExcercise = true;
    },
    handleDoneModalAssignExcercise() {
      this.getListClassGroupAssignExcercise();
      this.closeModalAssignExcercise();
    },
    getDetailLesson() {
      getDetail(this.lessonClassSchoolId).then((res) => {
        if (res && res.data && !res.errors) {
          this.dataLesson = res.data;
        }
      });
    },
    handelRecoveryDone() {
      this.getListClassGroupAssignExcercise();
      this.closeModalRecoveryAssign();
    },
    handleRecoveryAssign(row) {
      this.itemCurrentSelected = row.item;
      this.isOpenModalRecoveryAssign = true;
    },
    closeModalRecoveryAssign() {
      this.isOpenModalRecoveryAssign = false;
    },
    formatNumber(value) {
      if (typeof value !== "number") {
        return value;
      }
      return value.toFixed(2);
    },
    handleEditDuration(row) {
      //this.itemCurrentSelected = row.item;
      this.isOpenModalEditDuration = false;
      if (this.itemCurrentSelectedId > 0) this.itemCurrentSelectedId = 0
      else this.itemCurrentSelectedId = row.item.id
    },
    handleDoneUpdateDuration() {
      this.getListClassGroupAssignExcercise();
      this.closeModalEditDuration();
      this.itemCurrentSelectedId = 0
    },
    closeModalEditDuration() {
      this.isOpenModalEditDuration = false;
    },
    handleGetListUserAssign(item) {
      this.itemCurrentSelected = item;
      this.getListUserAssign();
    },
    getListUserAssign() {
      if (this.itemCurrentSelected.groupId > 0) {
        this.getListUserAssignByGroupId();
      } else {
        this.getListUserAssignByClassSchoolId();
      }
    },
    getListUserAssignByGroupId() {
      this.listDataUserAssign = [];
      getListUserAssingExcerciseByGroupId({
        groupId: this.itemCurrentSelected.groupId,
        keyword: this.groupId,
        type: this.itemCurrentSelected.type,
        id: this.lessonClassSchoolId,
        status: 1,
      }).then((res) => {
        if (res && res.data && !res.errors) {
          for (let i = 0; i < res.data.length; i++) {
            const item = res.data[i];
            this.listDataUserAssign.push({
              id: item.id,
              userId: item.userId,
              stt: i + 1,
              name: item.userName,
              isComplete: item.isComplete,
              point: item.point,
            });
          }
        }
      });
    },
    getListUserAssignByClassSchoolId() {
      this.listDataUserAssign = [];
      console.log(this.itemCurrentSelected);
      getListUserAssingExcerciseByClassSchoolId({
        classSchoolId: this.itemCurrentSelected.classSchoolId,
        keyword: this.keyword,
        type: this.itemCurrentSelected.type,
        id: this.lessonClassSchoolId,
      }).then((res) => {
        if (res && res.data && !res.errors) {
          console.log(res.data);
          for (let i = 0; i < res.data.length; i++) {
            const item = res.data[i];
            this.listDataUserAssign.push({
              id: item.id,
              userId: item.userId,
              stt: i + 1,
              name: item.userName,
              isComplete: item.isComplete,
              duration: item.duration,
              point: item.point,
            });
          }
        }
      });
    },
    getListClassGroupAssignExcercise() {
      this.listDataAssign = [];
      getListClassSchoolGroupAssignExcercise(this.paramQueryData).then(
        (res) => {
          if (res && res.data && !res.errors) {
            console.log(res.data);
            for (let i = 0; i < res.data.length; i++) {
              const item = res.data[i];

              this.listDataAssign.push({
                id: item.id,
                groupId: item.groupId,
                classSchoolId: item.classSchoolId,
                stt: i + 1,
                name: item.groupId > 0 ? item.groupName : item.classSchoolName,
                submissionRate: item.submissionRate,
                duration: item.duration,
                type: item.type,
              });
            }
            if (this.listDataAssign && this.listDataAssign.length > 0) {
              this.handleGetListUserAssign(this.listDataAssign[0]);
            }
          }
        }
      );
    },
    toggleCollapseGroup() { },
    hideDropdownEditDuration() {
      this.itemCurrentSelectedId = 0
    }
  },
};
</script>
<style lang="scss" scoped>
.icon-check-complete {
  width: 10px;
}

.margin-top-20 {
  margin-top: 20px;
}

.search-user {
  padding-right: 30px !important;
  margin-right: 11px
}

.icon-edit {
  width: 15px;
  cursor: pointer;
}

.wrap-assign {
  border: 1px solid #c1c1c1;
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 15px;
  background: #efeeee;
}

.b-scroll-table {
  max-height: 50vh;
  overflow-y: auto;
}

.wrap-table-assign {
  font-size: 13px;

  .field-name {
    color: #3d6be9;
    cursor: pointer;
  }

  .field-name:hover {
    color: #0f3dba;
    cursor: pointer;
  }
}

.btn-delete {
  color: red;
  cursor: pointer;
}

.col-table {
  font-size: 14px;
}

.icon-plus {
  width: 20px;
  top: 0px !important;
  display: inline-block;
}

.btn-add-class-assigned {
  position: absolute;
  bottom: 1rem;
}
</style>
